<template>
  <m-card905 :image="category.image">
    <h3>{{ category.name }}</h3>
    <m-button class="border border-light px-3 rounded-pill category-card-900" v-t="`category.card.more`"></m-button>
  </m-card905>
</template>

<script>
import {CategoryCardProps} from "./CategoryCardProps";
import {CategoryCardComputed} from "./CategoryCardComputed";
import mCard905 from "../../Cards/Card905";
import mButton from "../../Tags/Button";

export default {
  name: "CategoryCard900",
  components: {mCard905, mButton},
  props: {
    ...CategoryCardProps,
  },
  computed: {
    ...CategoryCardComputed
  }
}
</script>

<style scoped>
.category-card-900 {
  background: transparent;
  color: white;
  transition: .2s ease-in-out all;
}

.category-card-900:hover {
  background: white;
  color: black;
  transition: .2s ease-in-out all;
}
</style>